/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DaypartsDaypartIdMenusMenuIdItemsItemIdPut$Params {
  'Active-Tenant-Identifier': string;
  daypartId: string;

/**
 * Menu ID
 */
  menuId: string;

/**
 * Item (regular and category) ID
 */
  itemId: string;
}

export function daypartsDaypartIdMenusMenuIdItemsItemIdPut(http: HttpClient, rootUrl: string, params: DaypartsDaypartIdMenusMenuIdItemsItemIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, daypartsDaypartIdMenusMenuIdItemsItemIdPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('daypartId', params.daypartId, {});
    rb.path('menuId', params.menuId, {});
    rb.path('itemId', params.itemId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

daypartsDaypartIdMenusMenuIdItemsItemIdPut.PATH = '/dayparts/{daypartId}/menus/{menuId}/items/{itemId}';
